import React from 'react';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import config from '../../../../config';

const QualityCheckAnswerButton = (props) => {
  const { currentAnswer, qualityCheckRecord = {} } = props;
  const { selectedAnswer = {} } = qualityCheckRecord;
  return (
    <div
         data-testid='quality-check-answer-button'
         data-penalty={currentAnswer.Penalty || 0}
         className="quality-check-button-wrapper">
      <Button
        style={{ minWidth: 100, height: '100%' }}
        className={classNames('btn btn-lg quality-check-button', {
          selected: selectedAnswer.AnswerText == currentAnswer.AnswerText,
        })}
        onClick={() => {
          if (currentAnswer.AnswerText == selectedAnswer.AnswerText) {
            return props.qualityCheckAnswerHandler();
          }

          let dataToUpdate = { selectedAnswer: currentAnswer };
          dataToUpdate.checkedStatus = 'passed';
          let penaltyToApply = 'n/a';

          if (currentAnswer.Penalty && currentAnswer.Penalty > 0) {
            penaltyToApply = currentAnswer.Penalty;
            dataToUpdate.checkedStatus = 'failed';
          }

          if (selectedAnswer.Penalty) {
            /* if some answer was already selected, we increase total by this Penalty value back */
            if (penaltyToApply == 'n/a') {
              penaltyToApply = 0;
            }

            penaltyToApply = penaltyToApply - selectedAnswer.Penalty;
          }

          props.qualityCheckAnswerHandler({ dataToUpdate, penaltyToApply });
        }}
      >
        {`${currentAnswer.AnswerText}${
          config.getEnvironmentName() !== 'test' && config.getEnvironmentName() !== 'production' && currentAnswer.Penalty ? ` - ${currentAnswer.Penalty}` :  ''
        }`}
      </Button>
    </div>
  );
};

export default QualityCheckAnswerButton;
